import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import PendingApproval from '../pages/PendingApproval';
import EmailVerification from '../pages/EmailVerification';
import TrialExpired from '../pages/TrialExpired';

const ProtectedRoute = ({ children }) => {
  const { user, loading, subscription } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-dark-bg flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-carmin"></div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Admin users always pass through all gates
  if (user.is_admin) {
    return children;
  }

  // Gate 1: Email verification
  if (!user.email_verified) {
    return <EmailVerification />;
  }

  // Gate 2: Admin approval
  if (!user.approved) {
    return <PendingApproval />;
  }

  // Gate 3: Subscription/trial check
  if (subscription) {
    const isExpired = subscription.status === 'expired' ||
      subscription.status === 'past_due' ||
      (subscription.status === 'trialing' && subscription.trial_ends_at && new Date(subscription.trial_ends_at) < new Date());

    if (isExpired) {
      return <TrialExpired />;
    }
  }

  return children;
};

export default ProtectedRoute;
